module.exports = __webpack_public_path__ + "img/plus.b0c0d9f7.svg";